import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { DeleteRotationsplanDesktop } from '@/domain/mitarbeiter/features/rotationsplan/features/DeleteRotationsplan/DeleteRotationsplanDesktop';
import { DeleteRotationsplanMobile } from '@/domain/mitarbeiter/features/rotationsplan/features/DeleteRotationsplan/DeleteRotationsplanMobile';
import { ExportRotationsplanDesktop } from '@/domain/mitarbeiter/features/rotationsplan/features/ExportRotationsplan/ExportRotationsplanDesktop';
import { ExportRotationsplanMobile } from '@/domain/mitarbeiter/features/rotationsplan/features/ExportRotationsplan/ExportRotationsplanMobile';
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerTrigger,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuTrigger,
} from '@e2n/ui/v2';
import { faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function ActionDropdownMenu({
  rotationsplan,
}: {
  rotationsplan: Rotationsplan;
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button iconOnly variant="ghost-on-grey">
          <FontAwesomeIcon icon={faEllipsisVertical} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="min-w-32" align="end">
        <DropdownMenuGroup>
          <ExportRotationsplanDesktop
            rotationsplan={rotationsplan}
            onClose={() => setIsOpen(false)}
          />
          <DeleteRotationsplanDesktop
            rotationsplanId={rotationsplan.id}
            onClose={() => setIsOpen(false)}
          />
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export function ActionDrawer({
  rotationsplan,
}: {
  rotationsplan: Rotationsplan;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [view, setView] = useState<'delete' | undefined>();
  const { t } = useTranslation();

  return (
    <Drawer
      open={isOpen}
      onOpenChange={(open) => {
        setView(undefined);
        setIsOpen(open);
      }}>
      <DrawerTrigger asChild>
        <Button iconOnly variant="ghost-on-grey">
          <FontAwesomeIcon icon={faEllipsisVertical} />
        </Button>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerHeader />
        {view === undefined && (
          <DrawerBody className="items-stretch gap-2">
            <ExportRotationsplanMobile
              rotationsplan={rotationsplan}
              onClose={() => setIsOpen(false)}
            />
            <Button
              onClick={() => setView('delete')}
              className="font-normal text-error-red-200 w-full"
              variant="ghost">
              {t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.label',
              )}
            </Button>
          </DrawerBody>
        )}
        {view === 'delete' && (
          <DrawerBody>
            <DeleteRotationsplanMobile
              rotationsplanId={rotationsplan.id}
              handleClose={() => {
                setIsOpen(false);
              }}
            />
          </DrawerBody>
        )}
      </DrawerContent>
    </Drawer>
  );
}
